import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import getTimeDiff from 'shared/utils/getTimeDiff';

import CallTimer from './CallTimer';

const mapStateToProps = (state) => ({
  consultationStartedTime: state.conference.consultationStats.consultationStartedTime,
});

export default compose(
  connect(mapStateToProps),

  lifecycle({
    componentDidMount() {
      const updateCallTimerValue = () => {
        const { consultationStartedTime } = this.props;

        if (consultationStartedTime) {
          this.setState({ callTimerValue: getTimeDiff(consultationStartedTime) });
        }
      };

      this.timer = setInterval(updateCallTimerValue, 1000);
      updateCallTimerValue();
    },

    componentWillUnmount() {
      clearInterval(this.timer);
    },
  }),
)(CallTimer);
